<script>
import UsersApi from "@/services/users-api";
import simplebar from "simplebar-vue";
import Swal from "sweetalert2";
import i18n from "@/i18n";

export default {
    components: {
        simplebar
    },
    mounted(){
        this.getTraders()
        this.getPrivileges()
    },
    data(){
        return{
            pagemodelMain: {currentPage : 1, perPage : 10, totalRows: 0},
            tradersList:[],
            usersFilter:null,
            isUsersTableBusy:false,
            usersListFields: 
                [
                    { key:"name", label: "Nom",   sortable: false, tdClass:"font-weight-bold  ",},
                    { key:"jobTitle", label: "Fonction",thClass:"",tdClass:"" },
                    { key:"userName", label: "Login",thClass:"",tdClass:"" },
                    { key:"password", label: "Mot de passe",thClass:"",tdClass:"" },
                    { key:"status", label: "Statut",   thClass:"text-center", tdClass:"text-center"},
                    // { key:"clients", label: "Clients",thClass:"text-center", tdClass:"text-center"},
                    // { key:"privileges", label: "Privilèges",thClass:"text-center", tdClass:"text-center"},
                    { key:"actions", label:""}
                ],
            selectedUser:{id:'',name:'',userName:'',password:'',supplierId:null,status:1, extSystemId:'123456'},
            showPasswordModal:false,
            passwordHidden:true,
            newPassword:null,
            showClientsModal:false,
            clientsList:[],
            pagemodelCustomersList: {currentPage : 1, perPage :10, totalRows: 0},
            customersListFields: 
                [   
                    { key:"selection",label:"",thClass:"text-center align-middle", tdClass:"text-center align-middle"},
                    { key:"companyName", label: "",   sortable: false, thClass:"text-center align-middle", tdClass:"font-weight-bold align-middle ",},
                    { key:"country.name", label: "",   sortable: false,thClass:"text-center align-middle", tdClass:"font-weight-bold align-middle",},
                    { key:"city.name", label: "",   sortable: false ,thClass:"text-center align-middle", tdClass:"font-weight-bold align-middle",},
                ],
            customersListFieldsForAdmin: 
                [
                    { key:"companyName", label: "",   sortable: false, tdClass:"font-weight-bold ",},
                    { key:"country.name", label: "",   sortable: false, tdClass:"font-weight-bold ",},
                    { key:"city.name", label: "",   sortable: false, tdClass:"font-weight-bold ",},
                ],
            customerTableBusy:false,
            selectedCustomer:new Set(),
            editUsersModal:false,
            isNew:false,
            privilegesList:[],
            showPrivilegesModal:false,
            selectedPriviliges:[],
            showPrivilegesAlert:false,
            privilegesTableBusy:false,
            selectedUserPriviligesList:[],
            selectedUserPriviligesListFields: 
                [
                    { key:"fullName", label: "",   sortable: false, tdClass:"font-weight-bold ",},
                    { key:"actions", label:"",thClass:"text-right", tdClass:"text-right"}
                ],
            allCustomersAreSelected:0,
            editSelectionStaring:false,
            customersFilter:null
            
        }
    },
    methods:{
        getTraders(){
            this.isUsersTableBusy = true;
            UsersApi.getTraders(this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.usersFilter).then(
                  response => {    
                    this.tradersList= response.list
                    this.pagemodelMain.totalRows = response.total;
                    this.pagemodelMain.currentPage = response.page;
                    this.pagemodelMain.perPage = response.pageSize;
                    this.pagemodelMain.pageSize = response.pageSize;
                  }
              ).finally(() => {
             this.isUsersTableBusy = false;
                });
        },
        showHidePassword(){
            this.passwordHidden=!this.passwordHidden
        },
        changePassword(user){
            this.selectedUser=user
            this.passwordHidden=true
            this.newPassword=null
            this.showPasswordModal=true
        },
        updatePassword(){
            UsersApi.updatePassword(this.selectedUser.id,this.newPassword).then(
                (result)=>{
                    if(result){
                        this.showPasswordModal=false
                        this.selectedUser={}
                    }
                }
            )
        },

        getTradersClients(){
            this.customerTableBusy=true
            UsersApi.getTradersClients(this.pagemodelCustomersList.currentPage,this.pagemodelCustomersList.perPage,this.selectedUser==null ? null : this.selectedUser.id,this.customersFilter).then(
                (result)=>{
                    if(result){
                        this.clientsList=result.list
                        this.pagemodelCustomersList.totalRows = result.total;
                        this.pagemodelCustomersList.currentPage = result.page;
                        this.pagemodelCustomersList.perPage = result.pageSize;
                        this.pagemodelCustomersList.pageSize = result.pageSize;
                        var addedToTraderCount=0;
                        for(const i in this.clientsList){
                            if(this.clientsList[i].isAddedToTrader==1){
                                addedToTraderCount++;
                            }  
                        }
                        if(addedToTraderCount == this.pagemodelCustomersList.pageSize ){
                            this.allCustomersAreSelected = 1
                        }else{
                            this.allCustomersAreSelected = 0
                        }
                    }
                }
            ).finally(()=>{
                this.showClientsModal=true
                this.customerTableBusy=false
            })
        },

        addCustomersToTrader(){
            
            if(this.selectedUser.hasAdminPrivilege){
                return;
            }
            if(!this.selectedCustomer || !this.selectedCustomer.size){
                return;
            }
            let array = Array.from(this.selectedCustomer);

            UsersApi.addCustomersToTrader(array ,this.selectedUser==null ? null : this.selectedUser.id).then(
                (result)=>{
                    if(result){
                        this.getTradersClients(this.selectedUser)

                    }
                }
            )
        },

        removeCustomerFromTrader(customer){
            UsersApi.removeCustomerFromTrader(customer==null ? null : customer.id, this.selectedUser==null ? null : this.selectedUser.id).then(
                (result)=>{
                    if(result){
                        this.getTradersClients(this.selectedUser)
                    }
                }
            )
        },

        addNewTrader(){
            this.selectedUser={}
            this.cancelUserEdit()
            this.isNew=true
            this.passwordHidden=true
            this.editUsersModal=true
        },

        cancelUserEdit(){
            this.selectedUser.status=1;
            this.selectedUser.id=null
            this.selectedUser.name=''
            this.selectedUser.userName=''
            this.selectedUser.password=''
            this.selectedCustomer.extSystemId=''
        },

        saveUser(){

            

            this.selectedUser.supplierId= this.selected ? this.selected.id : null
            this.selectedUser.customerId= null
            UsersApi.saveUser(this.selectedUser).then(
                (result)=> {
                    if(result){
                        this.getTraders()          
                        this.cancelUserEdit()
                        this.editUsersModal=false
                    }

                }
            )
        },

        editUser(user){
            this.selectedUser.id=user.id
            this.selectedUser.status=user.status
            this.selectedUser.name=user.name
            this.selectedUser.userName=user.userName
            this.selectedUser.phone=user.phone
            this.selectedUser.jobTitle=user.jobTitle
            this.selectedUser.extSystemId=user.extSystemId;
            this.isNew=false
            this.editUsersModal=true
        },

        getPrivileges(){
            UsersApi.getPrivileges().then(
                response => {
                this.privilegesList=response;
                }
            )
        },

        getTradersPriviliges(user){
            this.selectedUser=user
            this.privilegesTableBusy=true
            UsersApi.getTradersPriviliges(user==null ? null : user.id).then(
                (result)=>{
                    if(result){
                        this.selectedUserPriviligesList=result
                    }
                }
            ).finally(()=>{
                this.showPrivilegesModal=true
                this.privilegesTableBusy=false
            })
        },

        addPriviligesToTrader(){
            if(!this.selectedPriviliges || !this.selectedPriviliges.length){
                this.showPrivilegesAlert=true;
                return;
            }
            let selectedPriviligesSet =  new Set()
            this.selectedPriviliges.forEach(function(item){
                selectedPriviligesSet.add(item.id)
            });
            let selectedPriviligesList = Array.from(selectedPriviligesSet);
            UsersApi.addPriviligesToTrader(selectedPriviligesList,this.selectedUser==null ? null : this.selectedUser.id).then(
                (result)=>{
                    if(result){
                        this.getTradersPriviliges(this.selectedUser)
                        this.getTraders()
                        this.showPrivilegesAlert=false
                        this.selectedPriviliges=[]

                    }
                }
            )

        },

        removePrivilegeFromTrader(privilege){
            Swal.fire({
                title: i18n.t('traders.swal.title.text1') +privilege.fullName+i18n.t('traders.swal.title.text2')+this.selectedUser.name,
                icon: "warning",
                showCancelButton: true,
                cancelButtonColor: "#f46a6a",
                confirmButtonColor: "#34c38f",
                cancelButtonText: i18n.t('traders.swal.cancelButtonText'),
                confirmButtonText: i18n.t('traders.swal.confirmButtonText')
            })        .then(result => {
            if (result.value) {
                UsersApi.removePrivilegeFromTrader(privilege==null ? null : privilege.id, this.selectedUser==null ? null : this.selectedUser.id).then(
                    (result)=>{
                        if(result){
                            this.getTradersPriviliges(this.selectedUser)
                            this.getTraders()
                        }
                    }
                )

                }
            });
        },

        editSelection(item){
            
            if(this.selectedUser.hasAdminPrivilege){
                return;
            }

            if(item == null){
                return;
            }
            
            this.editSelectionStaring=true

            let array = [];
            array.push(item.id)
            UsersApi.editSelection(array ,this.selectedUser==null ? null : this.selectedUser.id).then(
                (result)=>{
                    if(result){
                        this.getTradersClients(this.selectedUser)
                    }
                }
            ).then(
                ()=>{
                    this.editSelectionStaring=false
                }
            )
        },

        selectAllCustomers(){
            if(this.selectedUser.hasAdminPrivilege){
                return;
            }

            let array = [];

            for(const i in this.clientsList){
                array.push(this.clientsList[i].id)
            }

            UsersApi.editSelection(array ,this.selectedUser==null ? null : this.selectedUser.id).then(
                (result)=>{
                    if(result){
                        this.getTradersClients(this.selectedUser)
                    }
                }
            )

        },

        openClientsModal(user){
            this.selectedCustomer= new Set()
            this.pagemodelCustomersList= {currentPage : 1, perPage :10, totalRows: 0}
            this.selectedUser=user
            this.getTradersClients(user);

        }
        
        },


}
</script>

<template>
    <div>
        <div class="row mt-4">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <b-form-group >
                    <b-input-group  >
                        <b-form-input :placeholder="$t('traders.nameFilter')"   v-model="usersFilter"   @keyup.native.enter="getTraders() "
                            ></b-form-input>                              
                        <template v-slot:append>
                            <b-button variant="warning" @click="getTraders()" >
                            <i class="bx bx-search-alt font-weight-bold font-size-16 text-white align-middle"></i>
                            </b-button>
                        </template>
                    </b-input-group>
                </b-form-group>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <b-button variant="light" @click="addNewTrader()" class="mb-4 float-right">
                    <i class=" text-primary fas fa-plus-square font-size-16 font-weight-bold align-middle mr-2 "></i> 
                    <span class=" text-primary font-weight-bold">
                       {{$t('traders.addNew')}}  
                    </span>
                </b-button>
            </div>
        </div>
        <div class="table-responsive"> 
            <b-table 
            :busy="isUsersTableBusy"
            :striped="true"
            :small="false"
            :hover="true"
            :items="tradersList"
            :fields="usersListFields"
            :perPage="pagemodelMain.perPage"
            class="table  "
            >
            <template v-slot:table-busy>
                <div class="text-center my-2">
                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                </div>
            </template>
            <template v-slot:head(name)>
                {{ $t("traders.table.name") }} 
            </template>
            <template v-slot:head(jobTitle)>
                {{ $t("traders.table.jobTitle") }} 
            </template>
            <template v-slot:head(userName)>
                {{ $t("traders.table.userName") }} 
            </template>
            <template v-slot:head(password)>
                {{ $t("traders.table.password") }} 
            </template>
            <template v-slot:head(status)>
                {{ $t("traders.table.status") }} 
            </template>
            <!-- <template v-slot:head(clients)>
                {{ $t("traders.table.clients") }} 
            </template> -->
            <!-- <template v-slot:head(privileges)>
                {{ $t("traders.table.privileges") }} 
            </template> -->
            <template v-slot:cell(password)="{item}">
                <b-button @click="changePassword(item)"  size="sm" variant="outline-dark"  >
                    <i class="fas fa-key font-size-16 align-middle mr-2"></i>{{$t('traders.changePassword')}}
                </b-button>
            </template>
            <template v-slot:cell(status)="{value}">
                <i :class="value===1 ? 'fas fa-check text-success' : 'fas fa-ban text-danger' " ></i>
            </template>
            <template v-slot:cell(jobTitle)="{value}">
                {{value ? value : "_"}}
            </template>
            <!-- <template v-slot:cell(clients)="{item}">
                <i class="fas fa-user-tie text-info font-size-18" @click="openClientsModal(item)" style="cursor:pointer" ></i>
            </template> -->
            <!-- <template v-slot:cell(privileges)="{item}">
                <i class="fas fa-user-lock text-primary font-size-18" @click="getTradersPriviliges(item)" style="cursor:pointer" ></i>
            </template> -->
            <template v-slot:cell(actions)="{item}">
                <a  title="modifier" href="javascript:void(0);"  @click="editUser(item)" class="action-icon text-warning pr-2" >
                    <i class="fas fa-pencil-alt font-size-16"  />
                </a>
            </template>

            </b-table>
            <span v-if="!isUsersTableBusy & !tradersList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('traders.table.empty')}} </span>

        </div>
        <!-- Pagination -->
        <div class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getTraders()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }}</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodelMain.currentPage" :disabled="isUsersTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="getTraders()" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
        <b-modal
            v-model="showPasswordModal"
            :title="$t('traders.passwordModal.title')+selectedUser.name" 
            hide-footer 
            centered 
            title-class="text-primary"
            title-tag="h5"
            header-close-variant="danger"
        >
            <div class="form-group row">
                <label class="col-5 col-form-label" for="pwd">{{$t('traders.passwordModal.label')}} </label>
                <div class="col-5">
                        <b-input-group >
                          <b-form-input v-model="newPassword"  @keyup.native.enter="updatePassword()" :type="passwordHidden ? 'password':'text'" ></b-form-input>
                            
                          <template v-slot:append>
                              <b-button  size="sm" variant="dark"   >
                                <i :class="passwordHidden ?'fa fa-eye-slash':'display-eye fa fa-eye'" @click="showHidePassword ()" ></i>
                              </b-button>
                          </template> 
                        </b-input-group>
                </div>
                <div class="col-1"/>
                <div class="col-1">
                    <b-button variant="success" @click="updatePassword()">
                        <i class="fas fa-save font-size-14 align-middle  " ></i>
                    </b-button>
                </div>
            </div>

        </b-modal>

        <b-modal
                v-model="editUsersModal"
                :title="selectedUser.id ? $t('traders.editUsersModal.title1') : $t('traders.editUsersModal.title2') " 
                centered 
                title-class="text-primary"
                title-tag="h5"
                header-close-variant="danger"
                size="lg"
        >
            <div class="float-left">
                <div  class="form-group  ">
                    <b-form-checkbox
                        value="1"
                        unchecked-value="0"
                        class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                        v-model="selectedUser.status"
                        >   
                        <span class="font-size-14" :class="selectedUser.status == 1 ? 'text-info' : 'text-muted'">{{selectedUser.status == 1 ? $t('traders.editUsersModal.status.active') : $t('traders.editUsersModal.status.disabled')}}</span>
                    </b-form-checkbox>
                </div>
            </div>

            <div class="row mt-4" style="width:100%">
                <div class="form-group col-sm-4 pr-2">
                    <label >{{$t('traders.editUsersModal.table.name')}} </label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="selectedUser.name"
                    />
                </div>
                <div class="form-group col-sm-4 pr-2">
                    <label >{{$t('traders.editUsersModal.table.userName')}} </label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="selectedUser.userName"

                    />
                </div>
                <div v-if="isNew" class="form-group col-sm-4 pr-2">
                    <label >{{$t('traders.editUsersModal.table.password')}}</label>
                    <form autocomplete="off">
                        <div class="input-group">
                            <input class="form-control" :type="passwordHidden ? 'password':'text'" autocomplete="new-password" v-model="selectedUser.password">
                            <div class="input-group-append">
                                <span class="input-group-text"><i :class="passwordHidden ?'fa fa-eye-slash':'display-eye fa fa-eye'" @click="showHidePassword" ></i></span>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="form-group col-sm-4 pr-2">
                    <label >ID ERP</label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="selectedUser.extSystemId"

                    />
                </div>

                <div class="form-group col-sm-4 pr-2">
                    <label >{{$t('traders.editUsersModal.table.phone')}}</label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="selectedUser.phone"

                    />
                </div>
                <div class="form-group col-sm-4 pr-2">
                    <label >{{$t('traders.editUsersModal.table.jobTitle')}}</label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="selectedUser.jobTitle"

                    />
                </div>

                

            </div>

            <template v-slot:modal-footer>
            <b-button variant="secondary" @click="editUsersModal = false" size="md">{{$t('buttons.cancel')}}</b-button>
            <b-button  variant="warning" @click="saveUser()" size="md" ><span class="text-white font-weight-bold">{{$t('buttons.save')}}</span></b-button>
            </template>

        </b-modal>
        <b-modal
            v-model="showClientsModal"
            :title="$t('traders.tradersCustomersModal.title')+selectedUser.name" 
            hide-footer 
            centered 
            title-class="text-primary"
            title-tag="h5"
            header-close-variant="danger"
            no-close-on-backdrop
            size="lg"
        >

        <b-form-group :label="$t('traders.tradersCustomersModal.nameFilter.label')" >
            <b-input-group  >
                <b-form-input :placeholder="$t('traders.tradersCustomersModal.nameFilter.placeholder')"   v-model="customersFilter"   @keyup.native.enter="getTradersClients() "
                    ></b-form-input>                              
                <template v-slot:append>
                    <b-button variant="warning" @click="getTradersClients()" >
                    <i class="bx bx-search-alt font-weight-bold font-size-16 text-primary align-middle"></i>
                    </b-button>
                </template>
            </b-input-group>
        </b-form-group>
        <span v-if="!customerTableBusy & !clientsList.length" class="d-flex justify-content-center m-4 text-danger" > {{$t('traders.tradersCustomersModal.table.empty')}} </span>
        <simplebar  style="max-height: 25em;min-height: 25em;"  >

            <div class="table-responsive" style="max-height: 25em;min-height: 25em;" > 
                    <b-table 
                    :busy="customerTableBusy"
                    :striped="true"
                    :small="true"
                    :hover="true"
                    :items="clientsList"
                    :fields="selectedUser.hasAdminPrivilege ? customersListFieldsForAdmin :customersListFields"
                    :perPage="pagemodelCustomersList.perPage"
                    class="table  "
                    thead-class="d-none"
                    id="my-table"
                    >
                        <template v-slot:table-busy>
                            <div class="text-center my-2">
                                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                            </div>
                        </template>

                        <template v-slot:head(companyName)>
                            {{ $t("traders.tradersCustomersModal.table.name") }} 
                        </template>
                        <template v-slot:head(country)>
                            {{ $t("traders.tradersCustomersModal.table.country") }} 
                        </template>
                        <template v-slot:head(city)>
                            {{ $t("traders.tradersCustomersModal.table.city") }} 
                        </template>

                        <template v-slot:cell(selection)="{item}">
                        <b-form-checkbox
                            value="1"
                            unchecked-value="0"
                            class="custom-checkbox-success "
                            v-model="item.isAddedToTrader"
                            @input="editSelection(item)"
                            :disabled="editSelectionStaring"
                            ></b-form-checkbox>
                        </template>
                    </b-table>
            </div>

        </simplebar>

           <!-- Pagination -->
        <div class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getTradersClients(selectedUser)"  v-model="pagemodelCustomersList.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }}</span><span class="font-weight-bold"> {{pagemodelCustomersList.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodelCustomersList.currentPage" :disabled="customerTableBusy" :per-page="pagemodelCustomersList.pageSize" :total-rows="pagemodelCustomersList.totalRows" @input="getTradersClients(selectedUser)" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
        </b-modal>

        <b-modal
            v-model="showPrivilegesModal"
            :title="$t('traders.privilegesModal.title')+selectedUser.name" 
            hide-footer 
            centered 
            title-class="text-primary"
            title-tag="h5"
            header-close-variant="danger"
            no-close-on-backdrop
            size="lg"
        >
        <div class="row">
            <div class="col-12">
                <b-form-group :label="$t('traders.privilegesModal.privilegesList.label')" label-for="">
                    <v-select class="style-vselect" style="font-size:1.2em;" :options="privilegesList" multiple :placeholder="$t('traders.privilegesModal.privilegesList.placeholder')" label="fullName" v-model="selectedPriviliges">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                    </v-select>
                </b-form-group>
            </div>
        </div>
        <b-alert :show="showPrivilegesAlert" variant="danger" class="w-100">
            <i class="fas fa-exclamation-triangle mr-2"></i>{{$t('traders.privilegesModal.alert')}}
        </b-alert>

        <div class="row">
            <div class="col-12">
                <b-button @click="addPriviligesToTrader()" variant="light" class="float-right mt-2 mb-4 " :disabled="!selectedPriviliges.length">
                    <i class="fas fa-plus text-primary font-size-16 align-middle mr-2"></i>
                    <span class="font-weight-bold text-primary text-uppercase">{{$t('traders.privilegesModal.addPriviligesToTrader')}} </span>
                </b-button> 
            </div>
        </div>
        <span v-if="!privilegesTableBusy & !selectedUserPriviligesList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('traders.privilegesModal.table.empty')}} </span>

        <div class="table-responsive"> 
                <b-table 
                :busy="privilegesTableBusy"
                :striped="true"
                :small="true"
                :hover="true"
                :items="selectedUserPriviligesList"
                :fields="selectedUserPriviligesListFields"
                class="table  "
                thead-class="d-none"
                >
                    <template v-slot:table-busy>
                        <div class="text-center my-2">
                            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                        </div>
                    </template>
                                
                    <template v-slot:head(fullName)>
                            {{ $t("traders.privilegesModal.table.fullName") }} 
                        </template>
                    <template v-slot:cell(actions)="{item}">
                        <b-button @click="removePrivilegeFromTrader(item)"  size="sm" variant="outline-danger"  >
                            <i class="fas fa-times font-size-16 align-middle mr-2"></i>{{$t('traders.privilegesModal.table.removePrivilegeFromTrader')}}
                        </b-button>
                    </template>
                </b-table>
        </div> 

        </b-modal>
    </div>
</template>